import { TextInput } from '@soteria/design-system-ve';

import * as styles from './CommunityDialog.css';

interface StoreIntegrationSectionProps {
  contentStandardsUrl: string;
  setContentStandardsUrl: (value: string) => void;
  disabled?: boolean;
}

export function StoreIntegrationSection({ contentStandardsUrl, setContentStandardsUrl, disabled = false }: StoreIntegrationSectionProps) {
  return (
    <div className={styles.formSection}>
      <TextInput
        disabled={disabled}
        helperText="Must be a static HTML page or plain text, not dynamically rendered with JavaScript"
        id="contentStandardsUrl"
        label="Content Standards URL"
        placeholder="Enter content standards URL (optional)"
        value={contentStandardsUrl}
        onChange={(value: string) => setContentStandardsUrl(value)}
      />
    </div>
  );
}
